<template>
    <div>
        <div class="modal-mask" role="dialog">
            <div class="overlay-mask">
                <div class="modal-dialog modal-sm">
                    <div class="modal-content g-mt-170">
                        <div class="modal-body">
                            <div  v-on:click="Close()" class="close_btn"></div>
                            <div class="row g-my-20 g-mx-20">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 g-my-15">
                                    <label>E-Order #:</label><span> {{orderNumber}}</span><br>
                                    <label>Status:</label><span> {{visionWebOrderStatus}}</span><br>
                                    <label>Last Updated:</label><span> {{FormatDateToLocal(dateSubmitted)}}</span><br>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 center">
                                     <button v-on:click="Close()" class="btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-btn-130">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        components: {},
        props:['orderNumber', 'visionWebOrderStatus', 'dateSubmitted'],
        data(){
            return{

            }
        },
        methods: {
            Close(){
                this.$emit('close');
            }
        },
        created(){

        }
    }
</script>


// WEBPACK FOOTER //
// OrderTrackingVisionWebStatus.vue?f71a8c62